module.exports = __webpack_public_path__ + "static/media/logo138.8f1ba8eb.png";